import React from 'react';
import { connect } from 'shalala';

import 'react-bootstrap-typeahead/css/Typeahead.css';

import { useStore } from '../../../store';
import AvatarLetter from '../../../facturotopia/avatar-letter/AvatarLetter';
import FaAsyncTypeahead from '../../../facturotopia/fa-typahead/FaAsyncTypeahead';

class ReceptorSuggestionsList extends React.Component {
  state = {
    isLoading: false,
    options: [],
    query: '',
  };

  _cache = {};

  handleOnSelect = (item) => {
    this.props.onSelect(item);
  };

  render() {
    const { autoFocus = false, suggestions, suggestionsActions } = this.props;
    const { data } = suggestions;

    return (
      <FaAsyncTypeahead
        id="async-pagination-receptores"
        paginate
        autoFocus={autoFocus}
        placeholder="Buscar receptor..."
        paginationText="Mostrar más..."
        searchText="Buscando..."
        labelKey="rfc"
        options={data}
        filterBy={['id', 'razon_social', 'rfc', 'email']}
        container={{ state: suggestions, ...suggestionsActions }}
        renderMenuItemChildren={(option) => (
          <div key={option.id}>
            <AvatarLetter
              className="rounded-circle"
              alt={option.rfc}
              title={option.razon_social}
              style={{
                height: '30px',
                marginRight: '10px',
                width: '30px',
              }}
            />
            <span>{option.razon_social}</span>
            <br />
            <span>{option.rfc}</span>

            {option?.sector_primario_is_adquiriente && (
              <>
                <br />
                <span className="badge badge-primary">adquiriente</span>
              </>
            )}
          </div>
        )}
        onSelect={this.handleOnSelect}
      />
    );
  }
}

const mapState = (store) => {
  return { suggestions: store.app.receptores.suggestions };
};

const mapActions = (actions) => {
  return { suggestionsActions: actions.app.receptores.suggestions };
};

export default connect(useStore, mapState, mapActions)(ReceptorSuggestionsList);
